import { DATE_FORMAT } from "helpers/common";
import React from "react";

const STATUS = {
  "active": "Active",
  "completed": "Completed",
  "deleted": "Deleted"
}

const Columns = ({ handleEditHandler }) => [
  {
    dataField: "JackpotID",
    text: "JackpotID",
    formatter: (_, row) => <span className="text-capitalize">{row?.jackpotID}</span>,
  },
  {
    dataField: "ID",
    text: "ID",
    formatter: (_, row) => <span className="text-capitalize">{row?.userDetails?.username}</span>,
  },
  {
    dataField: "Username",
    text: "Username",
    formatter: (_, row) => <span className="text-capitalize">{row?.userDetails?.telegram_username ? row?.userDetails?.telegram_username : row?.userDetails?.first_name}</span>,
  },

  {
    dataField: "wonEnergy",
    text: "Won Energy",
    formatter: (_, row) => <span className="text">{row?.wonEnergy}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },

  {
    dataField: "wonBtnc",
    text: "Won BTNC",
    formatter: (_, row) => <span className="text">{row?.wonBtnc}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
 {
    dataField: "wonAmount",
    text: "Won Amount",
    formatter: (_, row) => <span className="text">$ {row?.wonAmount}</span>,
    sort: true,
    sortCaret: (order, column) => {
      if (!order) return (<span>&nbsp;&nbsp;▲▼</span>); // Default (no sort)
      else if (order === 'asc') return (<span>&nbsp;&nbsp;▲</span>); // Ascending
      else if (order === 'desc') return (<span>&nbsp;&nbsp;▼</span>); // Descending
      return null;
    },
  },
  {
    dataField: "status",
    text: "status",
    formatter: (_, row) => <span className="text-capitalize">{STATUS[row?.status]}</span>,
  },
  {
    text: "completedAt",
    dataField: "completed At",
    formatter: (_, row) => row.completedAt && DATE_FORMAT(row.completedAt),
  },
  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="Edit"
        onClick={() =>
          handleEditHandler(row)
        }
      ></button>
    ),
  },
];
export default Columns;
